export const config = {
    socketUrl: "wss://pdf-chat-api.touchcastmaas.dev/api/chat" /*"wss://pdf-chat-api.touchcastmaas.dev/api/chat" "ws://localhost:3002/api/chat"*/,
    //avatarApiUrl: 'https://genything-api-app2.touchcastmaas.dev', /*http://137.117.72.200:8000*/
    apiVersion: 'v3',
    // apiUrl: 'https://genything.touchcastgpt.com/',
    apiUrl: 'https://genything-recorder.touchcastmaas.dev/synth/',
    avatarStatusServer: "https://genything-api-demo25.touchcastmaas.dev",
    avatarApiUrl: 'https://avatar-management-gateway.touchcastmaas.com',
    orgId: 'ac5f57ad-a77e-4344-b3e7-a3c7a54908ae',
    assistantId: "asst_fC6dfcgNB8l1M0INSO8OFodb"
}
